import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export interface GetCompleteness {
  completeness: number;
}

export const dateFormat = "YYYY-MM-DD";

export type CompletenessType = "total" | "collecting" | "matching";

export function useCompleteness({ type, year }: { type?: CompletenessType; year?: number }) {
  let url = "dashboard/completeness";
  if (type === "collecting") {
    url = "dashboard/completeness/collecting";
  }
  if (type === "matching") {
    url = "dashboard/completeness/matching";
  }

  return useQuery({
    queryKey: ["dashboard", "getCompleteness", type, year],
    queryFn: () =>
      axios.get<GetCompleteness>(url, { params: year ? { year } : {} }).then((data) => data.data),
  });
}
